export default __webpack_public_path__ + "static/media/bitstop-app-layout-3.b0ecf581.png";